"use client";

import { c as _c } from "react/compiler-runtime";
import { useHasMounted } from "@/hooks/useHasMounted";
import { useCookieConsent } from "@/lib/cookies/useCookieConsent";
import { Cookie, Settings } from "lucide-react";
import { useState } from "react";
import { CookiePreferences } from "./CookiePreferences";
import type { CookieDictionary } from "./types";
interface CookieBannerProps {
  dictionary: CookieDictionary;
}
export function CookieBanner(t0) {
  const $ = _c(11);
  const {
    dictionary
  } = t0;
  const {
    hasInteracted,
    acceptAll,
    rejectAll
  } = useCookieConsent();
  const [showPreferences, setShowPreferences] = useState(false);
  const hasMounted = useHasMounted();
  if (!hasMounted || hasInteracted) {
    return null;
  }
  let t1;
  if ($[0] !== acceptAll || $[1] !== dictionary || $[2] !== rejectAll || $[3] !== showPreferences) {
    t1 = !showPreferences && <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-slide-up"><div className="mx-auto max-w-6xl"><div className="relative overflow-hidden rounded-2xl border border-sand-dark/20 bg-white-cream/95 shadow-2xl backdrop-blur-sm"><div className="absolute inset-0 bg-gradient-to-br from-terracotta/5 via-transparent to-forest-green/5" /><div className="relative p-6 md:p-8"><div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between"><div className="flex flex-1 gap-4"><div className="shrink-0"><div className="flex h-12 w-12 items-center justify-center rounded-full bg-terracotta"><Cookie className="h-6 w-6 text-white-cream" /></div></div><div className="flex-1 space-y-2"><h3 className="text-lg font-semibold text-forest-green">{dictionary.title}</h3><p className="text-sm leading-relaxed text-wood-natural">{dictionary.description}</p></div></div><div className="flex flex-col gap-3 sm:flex-row md:shrink-0"><button onClick={() => setShowPreferences(true)} className="flex items-center justify-center gap-2 rounded-lg border border-sand-dark bg-white-cream px-4 py-2.5 text-sm font-medium text-forest-green transition-all hover:bg-sand-light hover:shadow-md" aria-label={dictionary.customize}><Settings className="h-4 w-4" />{dictionary.customize}</button><button onClick={rejectAll} className="rounded-lg border border-sand-dark bg-white-cream px-4 py-2.5 text-sm font-medium text-wood-natural transition-all hover:bg-sand-light hover:shadow-md" aria-label={dictionary.rejectAll}>{dictionary.rejectAll}</button><button onClick={acceptAll} className="rounded-lg bg-terracotta px-6 py-2.5 text-sm font-semibold text-white-cream shadow-lg transition-all hover:bg-terracotta-light hover:shadow-xl" aria-label={dictionary.acceptAll}>{dictionary.acceptAll}</button></div></div></div></div></div></div>;
    $[0] = acceptAll;
    $[1] = dictionary;
    $[2] = rejectAll;
    $[3] = showPreferences;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== dictionary || $[6] !== showPreferences) {
    t2 = showPreferences && <CookiePreferences dictionary={dictionary} onClose={() => setShowPreferences(false)} />;
    $[5] = dictionary;
    $[6] = showPreferences;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}